var React = require('react');

function CircleCheck (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("g",{"key":0},React.createElement("path",{"fill":"#505aff","d":"M29.5 59C45.792 59 59 45.792 59 29.5S45.792 0 29.5 0 0 13.208 0 29.5 13.208 59 29.5 59z"})),React.createElement("g",{"key":1},React.createElement("path",{"fill":"#fff","d":"M24.7 44.403a2.116 2.116 0 0 1-1.48.597 2.116 2.116 0 0 1-1.48-.597L9.92 32.892a3 3 0 0 1 0-4.324l1.48-1.441a3.2 3.2 0 0 1 4.44 0l7.38 7.186 19.94-19.417a3.2 3.2 0 0 1 4.44 0l1.48 1.441a3 3 0 0 1 0 4.324z"}))]));
}

CircleCheck.defaultProps = {"width":"59","height":"59","viewBox":"0 0 59 59"};

module.exports = CircleCheck;

CircleCheck.default = CircleCheck;
